module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal6-25e562a0d710ceb1319b2c5905098e0e.jpg";